
export default [
  {
    path: '/test',
    name: 'TestHome',
    component: resolve => require(['./TestHome.vue'], resolve)
  },
  {
    path: '/test/list',
    name: 'ListTest',
    component: resolve => require(['./ListTest.vue'], resolve)
    
  },
  {
    path: '/test/queryApiTest',
    name: 'QueryApiTest',
    component: resolve => require(['./QueryApiTest.vue'], resolve)
  }
]



// WEBPACK FOOTER //
// ./src/components/abdp.sdk.test/index.js